import { BaseService } from "@kiddocare-platform/portal-common/base";

export class RepositoryPrescriptionsService extends BaseService {

  public async UploadAttachment(ticket: string, name: string, file: Blob) {
    try {
      const imgBody = new FormData();
      imgBody.append("media", file, name);
      const response = await this.AxiosInstance.post(`/parent/prescriptions/uploadAttachment/${ticket}/${name}`, imgBody, {
        headers: {
          "Accept": "application/json",
          "Content-Type": "multipart/form-data"
        }
      });
      return response.data;
    } catch (error: any) {
      this.log.error("Create", error.stack, JSON.stringify(error));
      throw error;
    }
  }

  public async Attachment(ticket: string, key: string): Promise<any> {
    try {
      const response = await this.AxiosInstance.get(`/parent/prescriptions/attachment/${ticket}/${key}`, {
        responseType: 'arraybuffer'
      });
      return response.data;
    }
    catch (error: any) {
      this.log.error("GetAttachment", error.stack, JSON.stringify(error));
      throw error;
    }
  }


  public async Order(ticket: string, key: string): Promise<any> {
    try {
      const response = await this.AxiosInstance.get(`/parent/prescriptions/order/${ticket}/${key}`, {
        responseType: 'arraybuffer'
      });
      return response.data;
    }
    catch (error: any) {
      this.log.error("GetRecipeDocument", error.stack, JSON.stringify(error));
      throw error;
    }
  }

  // public async Recipe(ticket: string, key: string): Promise<any> {
  //   try {
  //     const response = await this.AxiosInstance.get(`/pediatrician/prescriptions/recipe/${ticket}/${key}`, {
  //       responseType: 'arraybuffer'
  //     });
  //     return response.data;
  //   }
  //   catch (error: any) {
  //     this.log.error("GetRecipeDocument", error.stack, JSON.stringify(error));
  //     throw error;
  //   }
  // }



}
